import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SuppressionLists = lazy(() =>
  import("@scenes/SuppressionLists/components/SuppressionLists").then((module) => ({
    default: module.SuppressionLists,
  }))
);

export const suppressionListsNRO: NavigationRoutingObject = {
  section: "audience",
  Component: SuppressionLists,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("suppression-lists-nro-heading", "Suppression Lists"),
  pageNameForTracking: () => "Suppression Lists",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("suppression-lists-nro-description", "Exclude specific users from receiving messages"),
  icon: "nav-system-suppression-list",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/suppression_lists/:appGroupId",
};
